export default function formatPhoneNumber(number) {
  const cleaned = number.toString().replace(/\D/g, ""); // Remove non-digits
  return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3");
}
